import { ReactComponent as LogoDrConsulta } from '../assets/images/icons/logo-dr-consulta.svg';
import { ReactComponent as LogoUnimed } from '../assets/images/icons/logo-unimed.svg';
import { ReactComponent as LogoRededor } from '../assets/images/icons/logo-rededor.svg';
import { ReactComponent as LogoCentralConsultas } from '../assets/images/icons/logo-central-consultas.svg';
import { ReactComponent as LogoNipoBrasileiro } from '../assets/images/icons/logo-nipo-brasileiro.svg';

interface BenefitConfig {
    Icon: React.FC;
    label: string;
    backgroundColor: string;
    textColor: string;
    borderColor: string;
    testId: string;
}

export const EXAM_ORIGIN_BENEFIT: Record<string, BenefitConfig> = {
    DRC: {
      Icon: LogoDrConsulta,
      label: 'Ofertado pelo Dr. Consulta',
      backgroundColor: '#005CF8',
      textColor: '#FFF8F9',
      borderColor: 'transparent',
      testId: 'drc-icon',
    },
    'UNIMED-LITORAL': {
      Icon: LogoUnimed,
      label: 'Unimed Litoral',
      backgroundColor: '#00995C',
      textColor: '#FFF8F9',
      borderColor: 'transparent',
      testId: 'unimed-icon',
    },
    rededor: {
      Icon: LogoRededor,
      label: '',
      backgroundColor: '#1B5EA8',
      textColor: '#FFF8F9',
      borderColor: 'transparent',
      testId: 'rede-dor',
    },
    CENTRALDECONSULTAS: {
      Icon: LogoCentralConsultas,
      label: 'Central de Consultas',
      backgroundColor: '#15417A',
      textColor: '#FFF8F9',
      borderColor: 'transparent',
      testId: 'central-de-consultas',
    },
    'NIPO-BRASILEIRO': {
      Icon: LogoNipoBrasileiro,
      label: 'Hospital Nipo-Brasileiro',
      backgroundColor: '#FFFFFF',
      textColor: '#001A70',
      borderColor: '#001A70',
      testId: 'nipo-brasileiro',
    }
  };